import Vue from "vue";
import ResourceService from "./resource.service";

class RulesService extends ResourceService {
  static get resource() {
    return "financing/rules";
  }

  /**
   * Get all rules with pagination and filters
   * @param {Object} params - Query parameters (page, page_size, search, etc.)
   * @returns {Promise} - The rules data
   */
  static getRules(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(this.resource, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getBreaches(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get("financing/breaches", { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static updateBreach(breachId, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .patch(`financing/breaches/${breachId}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getBreach(breachId, params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`financing/breaches/${breachId}`, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static approveSilence(breachId) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`financing/breaches/${breachId}/approve-silence`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Get a specific rule by ID
   * @param {string|number} ruleId - The rule ID
   * @returns {Promise} - The rule data
   */
  static getRule(ruleId) {
    const url = `${this.resource}/${ruleId}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Create a new rule
   * @param {Object} ruleData - The rule data to create
   * @returns {Promise} - The created rule
   */
  static createRule(ruleData) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(this.resource, ruleData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Update an existing rule
   * @param {string|number} ruleId - The rule ID to update
   * @param {Object} ruleData - The rule data to update
   * @returns {Promise} - The updated rule
   */
  static updateRule(ruleId, ruleData) {
    const url = `${this.resource}/${ruleId}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .patch(url, ruleData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Delete a rule
   * @param {string|number} ruleId - The rule ID to delete
   * @returns {Promise} - The deletion response
   */
  static deleteRule(ruleId) {
    const url = `${this.resource}/${ruleId}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Get account rules for a specific credit line
   * @param {string} creditLineId - The credit line ID
   * @returns {Promise} - The account rules data
   */
  static getAccountRules(creditLineId) {
    let url = `financing/account-rules`;
    if (creditLineId) {
      url = `financing/account-rules?credit_line=${creditLineId}`;
    }
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Update account rules for a specific credit line
   * @param {string} creditLineId - The credit line ID
   * @param {Array} rulesData - Array of rules data to update
   * @returns {Promise} - The update response
   */
  static updateAccountRules(creditLineId, rulesData) {
    const url = `financing/account-rules`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, {rules: rulesData, account_id: creditLineId } )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default RulesService;
